import {Link, LinkProps} from 'react-router-dom';
import clsx from 'clsx';
import React, {useMemo} from 'react';
import {slugifyString} from '@ui/utils/string/slugify-string';
import {getBootstrapData} from '@ui/bootstrap-data/bootstrap-data-store';
import {Genre} from '@app/web-player/genres/genre';
import {isIOSOrAndroid} from '@common/core/platform-detection';
import {StackTrigger} from '@ui/overlays/stack-navigator/stack-trigger';
import {TagMediaPage} from '@app/web-player/genres/tag-media-page';

interface GenreLinkProps extends Omit<LinkProps, 'to'> {
  genre: Genre;
  className?: string;
}
export function GenreLink({genre, className, ...linkProps}: GenreLinkProps) {
  const uri = useMemo(() => {
    return getGenreLink(genre);
  }, [genre]);

  if (!isIOSOrAndroid()) {
    return (
      <Link
        {...linkProps}
        className={clsx(
          'block outline-none first-letter:capitalize hover:underline focus-visible:underline',
          className,
        )}
        to={uri}
      >
        {genre.display_name || genre.name}
      </Link>
    );
  }

  return (
    <StackTrigger
      moveFocusToDialog={false}
      title={genre.display_name || genre.name}
    >
      <div
        className={clsx(
          'block outline-none first-letter:capitalize hover:underline focus-visible:underline',
          className,
        )}
      >
        {genre.display_name || genre.name}
      </div>
      <TagMediaPage
        tagName={getGenreTagName(genre)}
        label={genre.display_name || genre.name}
      />
    </StackTrigger>
  );
}

export function getGenreTagName(genre: Genre) {
  return slugifyString(genre.name);
}

export function getGenreLink(
  genre: Genre,
  {absolute}: {absolute?: boolean} = {},
) {
  const genreName = getGenreTagName(genre);
  let link = `/tag/${genreName}`;
  if (absolute) {
    link = `${getBootstrapData().settings.base_url}${link}`;
  }
  return link;
}
